export function app() {

  return {
    overflowHidden: false,
    search: false,
    miniCart: false,
    currencyChangeAlert: false,
    bodyScrollY: 0,
    donorboxSrcs: [],
    donorboxSrc: null,
    donorboxModal: false,
    ticketTailorIds: [],
    ticketTailorId: null,
    ticketTailorModal: false,
    formAssemblySrcs: [],
    formAssemblySrc: null,
    formAssemblyModal: false,

    init() {
      this.$watch('Shopify.currencyChanged', () => {
        setTimeout(() => { this.currencyChangeAlert = true; }, 2000);
      });

      document.addEventListener('scroll', () => {
        if(window.scrollY > 0) {
          this.bodyScrollY = window.scrollY;
        }
      });

      // Donorbox links
      const donorboxLinks = document.querySelectorAll("a[href*=donorbox\\.org]");
      Array.from(donorboxLinks).forEach(link => {
        const urlMatch = link.href.match(/^https:\/\/donorbox\.org\/(.*)/);
        if(!urlMatch) return;
        const iframeSrc = link.href.replace('https://donorbox.org', 'https://donorbox.org/embed');
        if(!this.donorboxSrcs.includes(iframeSrc)) {
          link.setAttribute(
            'x-intersect.once',
            `donorboxSrcs.push('${iframeSrc}')`
          );
        }
        link.setAttribute(
          'x-on:click.prevent',
          `donorboxSrc = '${iframeSrc}'; donorboxModal = true; $dispatch('modal-open', { open: true })`
        );
      });

      // Ticket Tailor links
      const ticketTailorLinks = document.querySelectorAll("a[href*=buytickets\\.at\\/turnercontemporary]");
      Array.from(ticketTailorLinks).forEach(link => {
        const urlMatch = link.href.match(/^https:\/\/buytickets\.at\/turnercontemporary\/(.*)/);
        if(!urlMatch) return;
        const eventId = urlMatch[1];
        if(!this.ticketTailorIds.includes(eventId)) {
          link.setAttribute(
            'x-intersect.once',
            `ticketTailorIds.push('${eventId}')`
          );
        }
        link.setAttribute(
          'x-on:click.prevent',
          `ticketTailorId = '${eventId}'; ticketTailorModal = true; $dispatch('modal-open', { open: true })`
        );
      });

      // FormAssembly link
      // Only handle first found link, as FA embed script not compatible with multiple forms
      const formAssemblyLink = document.querySelector("a[href*=www\\.tfaforms\\.com]");
      if(!formAssemblyLink) return;

      const urlMatch = formAssemblyLink.href.match(/^https:\/\/www\.tfaforms\.com\/(.*)/);
      if(!urlMatch) return;

      const iframeSrc = formAssemblyLink.href.replace('https://www.tfaforms.com', 'https://www.tfaforms.com/publish');

      formAssemblyLink.setAttribute(
        'x-intersect.once',
        `formAssemblySrc = '${iframeSrc}'`
      );

      formAssemblyLink.setAttribute(
        'x-on:click.prevent',
        `formAssemblyModal = true;`
      );
    }
  };
}
